import { getRoles } from "@testing-library/react";
import axios from "axios";
import { getName, getToken, getUser } from "../Utils/Common";
import {
    getAPICall,
    getWithParamsAPICall,
    postAPICall,
    putAPICall,
} from "./axiosMethodCalls";

export const getSales = async (type, date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
            type: type,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "orders/getSales",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getMonthlySales = async (month) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            month:month,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/getMonthlySales",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getCashCounts = async () => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "cash_counts/getAll",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const showCashCount = async (id) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "cash_counts/show/"+id,
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getItemHistory = async (date_from, date_to, performing) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
            performing:performing
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/itemHistory",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getInventoryManager = async (date_from, date_to, menu) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
            menu_id: menu.id,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/stockin",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getQRrManual = async (date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/qrAndManualCount",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getXReading = async (date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_from,
            // account_id: "",
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/xreading",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};


export const getZReading = async (type,date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_from,
            type: type,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/zreading",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getDailySales = async () => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/hourly",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getAuditTrails = async (date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/auditTrails",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const generateAudit = async (date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date:date_to,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/generateAuditTrails",
            payload
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const getCancelledItems = async (type, date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
            type: type,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/cancelledItems",
            payload
        );
        return { data: response.data  };
    } catch (error) {
        return { error: error.response };
    }
};

export const getCancelledOrders = async ( date_from, date_to,type) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
            type: type,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/cancelledOrders",
            payload
        );
        return { data: response.data  };
    } catch (error) {
        return { error: error.response };
    }
};

export const getCancelledSI = async ( date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/cancelledSI",
            payload
        );
        return { data: response.data  };
    } catch (error) {
        return { error: error.response };
    }
};

export const getSeniorCitizenSales = async (date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/sc",
            payload
        );
        return { data: response.data  };
    } catch (error) {
        return { error: error.response };
    }
};

export const getPWDSales = async (date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/pwd",
            payload
        );
        return { data: response.data  };
    } catch (error) {
        return { error: error.response };
    }
};

export const getOtherSales = async (date_from, date_to) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from:date_from,
            date_to:date_to,
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/otherDiscount",
            payload
        );
        return { data: response.data  };
    } catch (error) {
        return { error: error.response };
    }
};

export const getCategoryReport = async (filter) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from: filter.date_from,
            date_to: filter.date_to,
            category_id: filter.category_id,
            pricelist: filter.pricelist
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/category",
            payload
        );
        return { data: response.data  };
    } catch (error) {
        return { error: error.response };
    }
};

export const getModifierReport = async (filter) => {
    try {
        var payload = {
            requester: getUser(),
            token: getToken(),
            date_from: filter.date_from,
            date_to: filter.date_to,
            modifier_id: filter.category_id === "all" ? '' : filter.category_id,
            pricelist: filter.pricelist
        };
      
        const response = await getWithParamsAPICall(
            process.env.REACT_APP_LINK + "reports/modifier",
            payload
        );
        return { data: response.data  };
    } catch (error) {
        return { error: error.response };
    }
};



